var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_CanvasLayerGroup = function (in_implements, in_extends, options) {
    // Need to extend the existing add layers feature
    var implements = [new Class(OCS.Viewer.Interfaces.LayerGroupCanvas)];
    var extend = null;
    if(in_extends) {
        extend = in_extends;
    }
    var class_definition = OCS.Viewer.Functions.define_layer_group(implements, extend, options);
    return new Class({
        Extends: class_definition,
        class_name: "CanvasLayerGroup"
    });
};